export const VERSION = 58;
export const VERSION_WEB = "1.1.2";
export const VERSION_DATE = "14/11 10:17";
export const VERSION_CONTENT = [
  "UMC-488: [UMC riêng] - Hiển thị ghi chú bác sĩ thay thế"
];
